import { combineReducers } from "redux";
import authReducer from "../../features/user/authSlice";
import headerSlice from "../../features/common/headerSlice";
import rightDrawerSlice from "../../features/common/rightDrawerSlice";
import modalSlice from "../../features/common/modalSlice";
import { leadsSlice } from "../../features/leads/leadSlice";
import labTestsReducer from "../../features/labTest/labTestsSlice";
import dnaSampleReducer from "../../features/dnaSample/dnaSampleSlice";
import pharmacyDetailsReducer from "../../features/settings/pharmacySettings/pharmacyDetailsSlice";
import profileReducer from "../../features/settings/profilesettings/profileSlice";
import pharmaciesSlice from "../../features/pharmacies/pharmaciesSlice";
import pharmacySlice from "../../features/pharmacy/pharmacySlice";
import labTestBookingSlice from "../../features/labTestBooking/labTestBookingSlice";
import statsSlice from "../../features/dashboard/statsSlice";
import categoriesReducer from '../../features/categories/categoriesSlice';
import tutorialsReducer from '../../features/tutorials/tutorialsSlice';
import testResultsReducer from '../../features/testResults/testResultsSlice';
import labclinicReducer from '../../features/labclinic/labclinicSlice';

const rootReducer = combineReducers({
  header : headerSlice,
  rightDrawer : rightDrawerSlice,
  modal : modalSlice,
  lead : leadsSlice,
  auth: authReducer,
  labTests: labTestsReducer,
  dnaSample: dnaSampleReducer,
  pharmacyDetails: pharmacyDetailsReducer,
  profile: profileReducer,
  pharmacies: pharmaciesSlice,
  pharmacy: pharmacySlice,
  labTestBookings: labTestBookingSlice,
  stats: statsSlice,
  categories: categoriesReducer,
  tutorials: tutorialsReducer,
  testResults: testResultsReducer,
  labclinic: labclinicReducer,
});

export default rootReducer;
